import { notifications } from '@mantine/notifications';
import type { TenbisMenuSyncResult } from 'shared-models/browser';

// One toast per sync: green when everything went, yellow with the skipped reasons otherwise.
export function notifyTenbisMenuSync(result: TenbisMenuSyncResult): void {
  const summary = `נשלחו ${result.itemCount} מנות ו-${result.choiceGroupCount} קבוצות תוספות לתן ביס`;
  if (result.skipped.length === 0) {
    notifications.show({ color: 'green', title: 'התפריט סונכרן', message: summary, autoClose: 4000 });
    return;
  }
  notifications.show({
    color: 'yellow',
    title: `התפריט סונכרן, ${result.skipped.length} פריטים דולגו`,
    message: `${summary}. דולגו: ${result.skipped.join(' | ')}`,
    autoClose: 8000,
  });
}
